import { ButtonContentTypes, ButtonTypes } from "constants/enumTypes.constants";
import Button from "components/common/Button/Button";
import PlusIcon from "images/circle_plus.svg";
import routeConstants from "routes/routeConstants";
import { useNavigate } from "react-router-dom";

const SearchButton = () => {
  const navigate = useNavigate();

  const handleNewSearch = () => {
    navigate(routeConstants.Search.path);
  };

  return (
    <Button
      buttonType={ButtonTypes.PRIMARY_SMALL}
      buttonContentType={ButtonContentTypes.ICON_TEXT}
      onClick={handleNewSearch}
      className="me-3">
      <img src={PlusIcon} alt="plus" />
      <span>New Search</span>
    </Button>
  );
};

export default SearchButton;
